import "./SolutionsSubpagesPage2.module.css";
import Header from "@/reusable_sections/Header";
import Intro from "./sections/Intro";
import StorytellingApproach from "./sections/StorytellingApproach";
import OurCoreServices from "./sections/OurCoreServices";
import VideoShowcase from "./sections/VideoShowcase";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function SolutionsSubpagesPage2() {
  return <div>
      <Header />
      <Intro />
      <StorytellingApproach />
      <OurCoreServices />
      <VideoShowcase />
      <CallToAction />
      <Footer />
    </div>;
}